export function getGlobal() {
    return ((typeof self === 'object' && self.self === self && self) ||
        (typeof global === 'object' && global.global === global && global) ||
        this);
}
//# sourceMappingURL=global.js.map